import { db } from "../../firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";

export const getAllPosts = async (collectionName = "posts") => {
  return await getDocs(collection(db, collectionName)).then(
    (snaps) => snaps.docs.map((d) => ({ id: d.id, ...d.data() })) // Include doc ID
  );
};

export const getAllMagazines = async () => {
  return await getAllPosts("magazines"); // Fetch from "magazines" collection
};

export const getAllPostsWithCategory = async (
  categoryId,
  collectionName = "posts"
) => {
  const q = query(
    collection(db, collectionName),
    where("categoryId", "==", categoryId)
  );
  return await getDocs(q).then((snaps) =>
    snaps.docs.map((d) => ({ id: d.id, ...d.data() }))
  );
};

export const getPost = async (id, collectionName = "posts") => {
  return await getDoc(doc(db, collectionName, id)).then((snap) => ({
    id: snap.id,
    ...snap.data(),
  }));
};
